import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import cookies from 'js-cookie';
import Routes from './routes';
import request from '../utils/request';
import Loading from '../Components/Loading';
import ChangeMonth from '../Components/ChangeMonth';
import NavigationBar from '../Components/NavigationBar';
import { version } from '../../package.json';

const App: React.FC = () => {
	const { pathname } = useLocation();
	const { replace, push } = useHistory();
	const [isAppInitialized, setAppInitialized] = useState(false);

	useEffect(() => {
		const JWT = cookies.get('jwt');
		if (JWT) {
			request.setToken(JWT);
		}
		window.replace = replace;
		window.push = push;
		setAppInitialized(true);
		window.appVersion = version;
	}, []);

	if (!isAppInitialized)
		return (
			<Loading center size={30} className='fullscreen-loading' isNormal />
		);

	return (
		<>
			<div
				id='main-wrapper'
				className={pathname !== '/login' ? 'is-login' : ''}
			>
				{pathname !== '/login' && pathname !== '/add' && (
					<>
						<ChangeMonth />
						<NavigationBar />
					</>
				)}
				<Routes />
			</div>
		</>
	);
};

export default App;
